export enum IncidentSeverity {
  // from least to most severe
  warning = 1,
  error = 2,
}

type IncidentCode = string

export function incidentSeverityOf(code: IncidentCode): IncidentSeverity {
  // There is currently no way to distinguish between warning and error incidents
  if (code === 'riskOfDelay') {
    return IncidentSeverity.warning
  }
  return IncidentSeverity.error
}

export type ShipmentIncident = {
  code: IncidentCode
  label: string
  icon?: string
  colorHexCode?: string
  remarks: string[]
  type?: string
}
